<div class="container-xxl">
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark p-0 navbar-custom-style">
        <div class="container-xxl">
            <a class="navbar-brand p-0" href="javascript:void(0)">
                <div class="logo-wrapper ps-0" id="logo-wrapper" (click)="goToHome()">
                    <a href="javascript:void(0)">
                        <img src="assets/img/logo_dark_crexendopoweredbynetsapiens.png" alt="CSP Logo"
                            *ngIf="!user">

                        <img src="{{user.header_logo}}" alt="CSP Logo" *ngIf="user && user.header_logo">
                    </a>
                    <span *ngIf="environment.envIndicator" class="badge bg-light text-dark env-indicator">Dev</span>
                    <span *ngIf="environment.staging" class="badge bg-light text-dark env-indicator">Staging</span>
                </div>
            </a>
            <button *ngIf="isLoggedIn" class="navbar-toggler navbar-toggler-bs-org" type="button"
                data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
                aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <!-- <div class="justify-content-end float-end" *ngIf="isLoggedIn">
                <form class="form-inline nav-search">
                    <input class="form-control form-control-sm" type="search" placeholder="Search" aria-label="Search">
                    <button class="btn btn-light btn-sm nav-search-btn" type="submit">Go</button>
                </form>
            </div> -->
            <div *ngIf="isLoggedIn">


                <div class="collapse navbar-collapse justify-content-end navbar-collapse-bs-org" id="navbarNavDropdown">
                    <ul class="navbar-nav pe-0">
                        <!-- <li class="nav-item dropdown user-profile user-profile-text" *ngIf="user">
                          
                        </li> -->
                        <li class="nav-item dropdown user-profile">
                            <a class="nav-link dropdown-toggle pe-0 ps-0" href="javascript:void(0)"
                                id="navbarDropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                                <!-- <img src="assets/img/profile.jpeg"> -->
                                <span class="picture-info">
                                    <img src="assets/img/Partner_avatar.png" alt="User" *ngIf="!isCustomerUser">
                                    <img src="assets/img/Customer_avatar.png" alt="User" *ngIf="isCustomerUser">
                                </span>
                                <div *ngIf="user" class="detail-info ">
                                    <span>{{user.user_name}} </span>
                                    <span class="d-none d-sm-inline-block">{{user.user_role}}&nbsp;({{user.user_id}})</span>
                                    <span class="d-inline-block d-sm-none">{{user.user_role === userRoles.superuser  ? 'SU' : user.user_role === userRoles.officemanager ? 'OM' : ''}}&nbsp;({{user.user_id}})</span>
                                    <span *ngIf="masquerading_user_id" class="isMasq">(masq -
                                        {{masquerading_user_id}})</span>
                                </div>
                            </a>
                            <!-- <div class="dropdown-menu dropdown-menu-end dropdown-menu-lg-left-end pullDown dropdown-menu-start"
                                aria-labelledby="navbarDropdownMenuLink">
                            </div> -->
                            <div class="dropdown-menu pullDown" aria-labelledby="navbarDropdownMenuLink">
                                <a *ngIf="user.user_role === userRoles.superuser" class="dropdown-item" href="javascript:void(0)" id="store-settings" (click)="settings()">Settings</a>
                                <a class="dropdown-item" href="javascript:void(0)" id="store-logout" (click)="logout()">Logout</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div *ngIf="isLoggedIn" class="mob-detail-info">
                <span>{{user.user_name}} </span>
                <span>SU&nbsp;({{user.user_id}})</span>
                <span *ngIf="user.masquerading_user_id" class="isMasq">(masq - {{user.masquerading_user_id}})</span>
            </div> -->
            <!-- <div *ngIf="isLoggedIn" class="mobLogoutBtn" title="Logout">
                <a href="javascript:void(0)" (click)="logout()">
                    <img src="assets/img/logouticon.png" width="35px" height="35px" alt="Logout">
                </a>
            </div> -->
            <div *ngIf="!isLoggedIn && !isLoginScreen && !partialLoggedIn" class="logginBtn ms-3" id="storeLoginBtn" title="Login">
                <a href="javascript:void(0)" routerLink="/dashboard/login/">
                    <img src="assets/img/loginIcon.png" width="35px" height="35px" alt="Login">
                </a>
            </div>
        </div>
    </nav>
</div>
 <div class="modal" id="updatePartnerModal" tabindex="-1">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">
                                    <span>Update CSP</span>
                                </h5>
                            </div>
                            <div class="modal-body">
                                <app-update-csp [data]="partnerData" [formElemConfig]="partnerUpdateFormElemConfig"
                                    [partnerAppAccessLevels]="partner_app_access_levels"
                                    [partnerRegistrationStatuses]="partner_registration_statuses"
                                    (formChangeEvent)="updatePartnerFormChange($event)"
                                    [fromComponent]="componentNames.header"
                                    [sectionName]="sectionNames.main"></app-update-csp>
                            </div>
                            <div class="modal-footer" *ngIf="updatePartnerForm">
                                <button class="btn btn-sm btn-custom-pri" id="updateParterModalBtn"
                                    [disabled]="updatePartnerForm.invalid" (click)="updatePartner()">
                                    <span>Update</span>
                                </button>
                                <button type="button" id="updatePartnerModalCacnelBtn" class="btn btn-sm btn-secondary"
                                    (click)="updatePartnerForm.reset()" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>